import fieldDataClient from "../../api/digitalTwin/fieldDataClient";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchPlantsMeasurementsFailure,
  fetchPlantsMeasurementsStart,
  fetchPlantsMeasurementsSuccess,
} from "../../store/features/digitalTwin/plantsMeasurementsSlice";

const URL = "/plant_measurements/";

const getPlantsMeasurements = async ({ plant_id, field_id }) => {
  try {
    const limit = 100;
    let offset = 0;
    let allMeasurements = [];
    let latestResponse = null;

    do {
      const response = await fieldDataClient.get(URL, {
        params: {
          plant_id,
          field_id,
          order_by: "survey_timestamp",
          order_dir: "desc",
          limit,
          offset,
        },
      });

      latestResponse = response.data;
      allMeasurements = allMeasurements.concat(response.data?.data || []);
      offset += limit;
    } while (latestResponse?.total > allMeasurements.length);

    return {
      ...latestResponse,
      data: allMeasurements,
      count: allMeasurements.length,
      offset: 0,
    };
  } catch (error) {
    console.log("here error", error);
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchPlantsMeasurementsSaga(action) {
  try {
    const { plant_id, field_id } = action.payload;
    const plantsData = yield call(getPlantsMeasurements, { plant_id, field_id });
    yield put(fetchPlantsMeasurementsSuccess(plantsData));
  } catch (error) {
    yield put(fetchPlantsMeasurementsFailure(error.message));
  }
}

export default function* plantsSaga() {
  yield takeLatest(fetchPlantsMeasurementsStart.type, fetchPlantsMeasurementsSaga);
}
